import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ar'],
    fallbackLng: 'en',
    ns: ['layout',
      'teacherregistration',
      'schoolprofile',
      'studentregistration',
      'editteacher',
      'editstudent',
      'studentprofile',
      'teacherprofile',
      'editparent',
      'dashboard',
      'classmanagement',
      'sessionmanagement',
      'emailsender',
      'parentmessaging',
      'attendancedashboard',
      'parentprofile',
      'studentlist',
      'teacherslist',
      'parentlist',
      'subjects',
      'subjectcategories',
      'academicyearsmanagement',
      'examconfigmanagement',
      'exammanagement',
      'examsmarksheet',
      'examweightconfig',
      'gradingscales',
      'markentry',
      'meritlistanalytics',
      'rawscoreresults',
      'billmanagement',
      'feemanagementdashboard',
      'feestructureitems',
      'feestructures',
      'payment'
    ],
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    interpolation: {
      escapeValue: false,

      format: function(value, format, lng) {
        if (format === 'date') {
          return new Intl.DateTimeFormat(lng).format(value);
        }
        if (format === 'number') {
          return new Intl.NumberFormat(lng).format(value);
        }
        return value;
      }
    },

    plural: {
      numbers: {
        ar: [0, 1, 2, 3, 11, 100],
        en: [1, 2]
      }
    }
  });

  i18n.on('languageChanged', (lng) => {
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  });

export default i18n;